import { Component, inject, OnInit } from '@angular/core';
import { ProductApiService } from '../../../services/product-api.service';
import { Category } from '../../../../../shared/models/category';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType, ToastPosition } from '../../../../../notifications/models/toast-notification-type';
import { Occasion } from '../../../../../shared/models/occasion';
import { CommonModule } from '@angular/common';
import { Subcategory } from '../../../../../shared/models/subcategory';
import { FormsModule, NgForm } from '@angular/forms';
import { PriceInputComponent } from '../../../../../shared/price-input/price-input.component';
import { ImageUploaderComponent } from '../../../../../shared/image-uploader/image-uploader.component';
import { Variant, VariantFormComponent } from '../../../../../shared/variant-form/variant-form.component';
import { Product } from '../../../../../shared/models/product-list';
import { ProductFormComponent } from '../../../../../shared/product-form/product-form.component';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/translations/language.service';
import { ApiErrorService } from '../../../../../shared/services/api-error.service';

@Component({
  selector: 'app-add-product-page',
  imports: [CommonModule, FormsModule, ProductFormComponent, TranslateModule, RouterLink],
  templateUrl: './add-product-page.component.html',
  styleUrl: './add-product-page.component.css'
})
export class AddProductPageComponent {

  toastNotificationService = inject(ToastNotificationService);
  apiService = inject(ProductApiService);
  apiErrorService = inject(ApiErrorService);
  translate = inject(TranslateService);
  languageService = inject(LanguageService);

  disableSubmitButton = false;
  loading = false;
  router = inject(Router);

  postProduct(payload: Product): void {
    this.disableSubmitButton = true;
    this.loading = true;
    this.apiService.postProduct(payload).subscribe({
      next: (response) => {
        this.disableSubmitButton = false;
        this.loading = false;
        this.toastNotificationService.createNotification(this.translate.instant('products.success.added_message'), ToastNotificationType.SUCCESS, this.translate.instant('products.success.added_title'), ToastPosition.TOP_RIGHT);
        this.router.navigate([`/products/${response.id}`]);
      },
      error: (err) => {
        this.disableSubmitButton = false;
        this.loading = false;
        this.toastNotificationService.createNotification(this.apiErrorService.getDisplayMessage(err, this.translate.instant('products.errors.generic_failed')), ToastNotificationType.ERROR, this.translate.instant('products.errors.add_failed_title'), ToastPosition.TOP_RIGHT);
      }
    });
  }

  // Form Submit
  submit(form: Product) {
    this.postProduct(form);
  }
}
